import axiosInstance from "./axiosInstance";
import Configs from "../utils/Configs";

const AccountApi = {
  fetchFewUserDetails: async () => {
    try {
      const response = await axiosInstance.get(Configs.fewUserDetailsEp);
      console.log("Few user details response:", response.data);
      return response.data; // Returns { status: "success", data: {...} }
    } catch (error) {
      console.error("Failed to fetch few user details:", error.message);
      return { status: "fail", data: error.message };
    }
  },
  toggleHidePhotosFromCountrymates: async (userId) => {
    try {
      const response = await axiosInstance.post(
        Configs.toggleHidePhotosFromCountrymatesEp,
        { user_id: userId },
      );

      return response.data.status === "success";
    } catch (error) {
      console.error(
        "Failed to toggle hide photos from countrymates:",
        error.message,
      );
      return false;
    }
  },

  verifyEmail: async ({ email, verificationCode }) => {
    try {
      const response = await axiosInstance.post(Configs.verifyEmailEp, {
        email: email,
        verification_code: verificationCode,
      });

      return response.status === 200 ? response.data : null;
    } catch (error) {
      console.error("Failed to verify email:", error.message);
      throw new Error(`Error verifying email: ${error.message}`);
    }
  },
  updateSocialMedia: async ({
    userId,
    facebook,
    instagram,
    twitter,
    tiktok,
  }) => {
    try {
      const response = await axiosInstance.post(Configs.updateSocialMediaEp, {
        user_id: userId,
        facebook: facebook,
        instagram: instagram,
        twitter: twitter,
        tiktok: tiktok,
      });

      return response.status === 200 ? response.data : null;
    } catch (error) {
      console.error("Failed to update social media:", error.message);
      throw new Error(`Error updating social media: ${error.message}`);
    }
  },

  updateLocation: async ({ userId, country, countryName, area }) => {
    try {
      const response = await axiosInstance.post(Configs.updateLocationEp, {
        user_id: userId,
        country: country,
        country_name: countryName,
        area: area,
      });

      return response.status === 200 ? response.data : null;
    } catch (error) {
      console.error("Failed to update location:", error.message);
      throw new Error(`Error updating location: ${error.message}`);
    }
  },

  updateLastSeen: async (userId) => {
    try {
      const response = await axiosInstance.post(Configs.updateLastSeenEp, {
        user_id: userId,
      });

      return response.status === 200 ? response.data : null;
    } catch (error) {
      console.error("Error in updateLastSeen:", error.message);
      return null;
    }
  },
  deleteAccount: async (userId, password) => {
    try {
      const response = await axiosInstance.post(Configs.deleteAccountEp, {
        user_id: userId,
        password: password,
      });

      return response.data;
    } catch (error) {
      console.error("Failed to delete account:", error);
      return null;
    }
  },
  toggleShowPhotosToAnonymous: async (userId) => {
    try {
      const response = await axiosInstance.post(
        Configs.toggleShowPhotosToAnonymousEp,
        { user_id: userId },
      );

      return response.data.status === "success";
    } catch (error) {
      console.error(
        "Failed to toggle photos visibility to anonymous users:",
        error.message,
      );
      return false;
    }
  },

  toggleHidePhotos: async (userId) => {
    try {
      const response = await axiosInstance.post(
        Configs.toggleShowHidePhotosEp,
        { user_id: userId },
      );

      return response.data.status === "success";
    } catch (error) {
      console.error("Failed to toggle hide photos:", error.message);
      return false;
    }
  },
  getUserNameByAccount: async (ref) => {
    try {
      const response = await axiosInstance.get(
        `${Configs.apiGetUserNameByAccountEp}?ref=${encodeURIComponent(ref)}`,
      );

      console.log("User name by account response:", response.data);

      return response.data;
      // { status: "success", data: { ref, full_name } }
    } catch (error) {
      console.error("Failed to fetch user name by account:", error.message);

      return { status: "fail", data: error.message };
    }
  },

  toggleAccountStatus: async (userId, password) => {
    try {
      const response = await axiosInstance.post(Configs.toggleStatusEp, {
        user_id: userId,
        password: password,
      });

      return response.data;
    } catch (error) {
      console.error("Error in toggleAccountStatus:", error);
      return null;
    }
  },
};

export default AccountApi;
